import { useEffect, useState } from "react";
import { AdditionalQuestions } from "../../../utils/types";
import { toast } from "react-toastify";

export function CreateQuestionModal({
  saveQuestion,
  questions,
  selectedQuestionToEdit,
  editQuestion,
}: {
  saveQuestion: (data: AdditionalQuestions) => void;
  questions: AdditionalQuestions[];
  selectedQuestionToEdit: AdditionalQuestions | null;
  editQuestion: (data: AdditionalQuestions[]) => void;
}) {
  const [question, setQuestion] = useState(
    selectedQuestionToEdit?.question ?? ""
  );
  const [isRequired, setisRequired] = useState(
    selectedQuestionToEdit?.required ?? false
  );

  useEffect(() => {
    if (selectedQuestionToEdit) {
      setQuestion(selectedQuestionToEdit.question);
      setisRequired(selectedQuestionToEdit.required);
    }
  }, [selectedQuestionToEdit]);

  const handleCreateQuestion = () => {
    if (!question || question.length < 3)
      return toast.error("Please enter a valid question");
    if (selectedQuestionToEdit) {
      const questionIndex = questions.findIndex(
        (q) => q.question === selectedQuestionToEdit.question
      );
      questions[questionIndex] = {
        ...questions[questionIndex],
        question,
        required: isRequired,
      };
      editQuestion([...questions]);
    } else {
      if (
        questions.find(
          (q) => q.question.toLowerCase() === question.toLowerCase()
        )
      )
        return toast.error("Question already exists");
      saveQuestion({ question, required: isRequired });
    }
    setQuestion("");
    setisRequired(false);
    document.getElementById("create-question-modal-close-btn")?.click();
  };

  return (
    <>
      <div
        className='modal fade create-question-modal'
        id='create-question-modal'
        tabIndex={-1}
        aria-labelledby='create-question-modal-label'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title fs-5' id='create-question-modal-label'>
                Add Question
              </h1>
              <button
                type='button'
                className='bttn-close'
                id='create-question-modal-close-btn'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='bi bi-x-circle'></i>
              </button>
            </div>
            <div className='modal-body'>
              <div className='form-group'>
                <p>Question</p>
                <textarea
                  className='form-control'
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                />
                <div className='form-check form-switch form-check-reverse'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id='switchCheckReverse'
                    checked={isRequired}
                    onChange={(e) => setisRequired(e.target.checked)}
                  />
                  <label
                    className='form-check-label'
                    htmlFor='switchCheckReverse'
                  >
                    is Required
                  </label>
                </div>
              </div>

              <div className='create-ticket-btn-container'>
                <button
                  disabled={question.length < 3}
                  onClick={handleCreateQuestion}
                  className='create-ticket-btn'
                >
                  Create Question
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
